import React, {useEffect, useState, Fragment} from 'react';
import { useNavigate, useParams} from 'react-router-dom';
import axios from 'axios';
import {API_BASE_URL} from '../config';
import '../assets/css/Client.css';
import '../assets/css/Dashboard.css';
import {formatDateBeautiful, formatDateDDMMYYYY} from "../utils/dateUtils";
import TicketModal from "../components/Ticketing/TicketModal";
import SectionTechnique from "../components/Client/SectionTechnique";
import SectionTechniqueDetails from "../components/Client/SectionTechniqueDetails";
import SectionTechniqueDetailsHebergeur from "../components/Client/SectionTechniqueDetailsHebergeur";
import SectionTechniqueDetailsEmails from "../components/Client/SectionTechniqueDetailsEmails";
import SectionTechniqueDetailsDNSZone from "../components/Client/SectionTechniqueDetailsDNSZone";
import SectionTechniqueDetailsResume from "../components/Client/SectionTechniqueDetailsResume";
import SectionTechniqueDetailsContactTechnique from "../components/Client/SectionTechniqueDetailsContactTechnique";
import SectionTechniqueDetailsDomaine from "../components/Client/SectionTechniqueDetailsDomaine";
import InfosBexio from "../components/Client/InfosBexio";
import DetailsEntreprise from "../components/Client/DetailsEntreprise";
import ReactQuill from "react-quill-new";
import Button from "../components/Elements/Button";
import {cleanString} from "../utils/textUtils";
import {getColorFromProgress} from "../utils/colorTextUtils";

const Client = () => {
    const navigate = useNavigate();
    let {id} = useParams(); // Get the 'id' parameter from the URL
    id = parseInt(id);
    const [totalPositions, setTotalPositions] = useState([]);
    const [totalPositionsSearch, setTotalPositionsSearch] = useState([]);
    const [bexioNr, setBexioNr] = useState(0);
    const [email, setEmail] = useState('');
    const [consultantEmail, setConsultantEmail] = useState(null);
    const [businessData, setBusinessData] = useState([]);
    const [messageState, setMessageState] = useState('Envoyer');
    const [avis, setAvis] = useState([]); // Initialize as an empty array
    const [isChecked, setIsChecked] = useState(false);
    const [customerTickets, setCustomerTickets] = useState([]);
    const [modalTickets, setModalTickets] = useState(false)
    const [totalTicketsSearch, setTotalTicketsSearch] = useState([]);
    const [contactPeople, setContactPeople] = useState([])
    const [activeUser, setActiveUser] = useState([]);
    const [activeTab, setActiveTab] = useState('home');
    const [customerWebsites, setCustomerWebsites] = useState([]);
    const [note, setNote] = useState("")

    const [activeTechOption, setActiveTechOption] = useState('resume');
    const [formData, setFormData] = useState({
        subject: '', url: '', clientEmail: '', clientName: '', contentFile: '', clientID: ''
    });

    const toggleModalTicket = () => {
        setModalTickets((prev) => !prev)
    }
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [siteUrl, setSiteUrl] = useState('');

    const handleTemplateChange = (e) => {
        const value = e.target.value;
        setSelectedTemplate(value);
        setFormData({...formData, subject: value});
        console.log(value)
        if (value !== "Votre nouveau site est en ligne") {
            setSiteUrl('');
        }
    };

    const handleSearchChange = (event) => {
        const term = event.target.value;

        console.log(term)
        if (term.length >= 1) {
            const filtered = totalPositions.filter(item => ((item.text && item.text.toLowerCase().includes(term.toLowerCase())) || (item.title && item.title.toLowerCase().includes(term.toLowerCase())) || (item.order_id && item.order_id.toString().includes(term))));
            setTotalPositionsSearch(filtered);
        } else {
            setTotalPositionsSearch(totalPositions);
        }
    };
    const handleSearchTicketChange = (event) => {
        const term = event.target.value;

        if (term.length >= 1) {
            const filtered = totalPositions.filter(item => ((item.url && item.url.toLowerCase().includes(term.toLowerCase())) || (item.address && item.address.toLowerCase().includes(term.toLowerCase())) || (item.name_1 && item.name_1.toLowerCase().includes(term.toLowerCase())) || (item.branch_names && item.branch_names.toLowerCase().includes(term.toLowerCase())) || (item.city && item.city.toLowerCase().includes(term.toLowerCase())) || (item.version && item.version.toLowerCase().includes(term.toLowerCase())) || (item.server && item.server.toLowerCase().includes(term.toLowerCase())) || (item.username && item.username.toLowerCase().includes(term.toLowerCase())) || (item.title && item.title.toLowerCase().includes(term.toLowerCase())) || (item.order_id && item.order_id.toString().includes(term))));
            setCustomerTickets(filtered);
        } else {
            setCustomerTickets(customerTickets);
        }
    };


    useEffect(() => {
        console.log(customerTickets)
        console.log(bexioNr)

        axios.post(`${API_BASE_URL}/get_customer_prod_websites`, {bexio_customer_id: bexioNr})
            .then(res => {
                if (res.data) {
                    console.log(res.data)
                    setCustomerWebsites(res.data)
                }
            });
    }, [bexioNr])

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_tickets_per_customer_client_query`, {id})
            .then(res => {
                if (res.data) {
                    setCustomerTickets(res.data)
                    setTotalTicketsSearch(res.data)
                }
            });
    }, [id])
    const handleSiteUrlChange = (e) => {
        const value = e.target.value;
        setSiteUrl(value);
        setFormData({...formData, url: value});
    };

    const handleToggle = () => {
        const newValue = !isChecked ? 1 : 0;
        setIsChecked(!isChecked);
        axios.post(`${API_BASE_URL}/update_customer_avis`, {id, avis: newValue});
    };

    // Récupération des avis client
    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_customer_avis`, {id: id})
            .then(res => {
                setAvis(res.data.datas);

                if (res.data.datas && res.data.datas[0].email !== undefined) {
                    setEmail(res.data.datas[0].email);
                }
            });

        if (!formData) {
            // Fetch customer info
            axios.post(`${API_BASE_URL}/get_customer_info`, {id})
                .then(res => {
                    if (res.data[0]) {
                        setBexioNr(res.data[0].nr)
                        setBusinessData(res.data[0])
                        setConsultantEmail(res.data[0].email)
                        setEmail(res.data[0].mail)
                        setSiteUrl(res.data[0].url)
                        console.log(res.data)
                        setFormData(res.data[0])
                        setIsChecked(res.data[0].avis === 1);
                        setActiveUser(res.data[0])
                        setNote(res.data[0].note)
                        document.title = `Client - ${res.data[0].name_1}`;
                    }
                });
        }

        axios.post(`${API_BASE_URL}/get_customer_info`, {id})
            .then(res => {
                if (res.data[0]) {
                    setBexioNr(res.data[0].nr)
                    setBusinessData(res.data[0])
                    setConsultantEmail(res.data[0].email)
                    setEmail(res.data[0].mail)
                    setSiteUrl(res.data[0].url)
                    console.log(res.data)
                    setFormData(res.data[0])
                    setIsChecked(res.data[0].avis === 1);
                    setActiveUser(res.data[0])
                    setNote(res.data[0].note)
                    document.title = `Client - ${res.data[0].name_1}`;
                }
            });


        // Fetch customer positions
        axios.post(`${API_BASE_URL}/get_customer_positions`, {id})
            .then(res => {
                setTotalPositions(res.data);
                setTotalPositionsSearch(res.data);
            });

        // Récupère les relations du client
        axios.post(`${API_BASE_URL}/get_customers_relations`, {id})
            .then(res => {
                setContactPeople(res.data.data);
            });
    }, [id]);

    const handleNote = (e) => {
        axios.post(`${API_BASE_URL}/set_customer_note`, {note: e, id: id})
            .then(setNote(e))

    }
    const handleChangeEmail = (val) => {
        setEmail(val)
    }

    const validateForm = () => {
        if (formData.subject === '') {
            alert("Vous devez sélectionner un modèle d'email");
            return false;
        }

        if (formData.subject === 'Votre nouveau site internet est en ligne' && formData.url === "") {
            alert("Vous devez remplir le champ URL pour cette demande");
            return false;
        }

        return true;
    };

    // Updated handleToggleTech that updates the parent state based on the selected option
    const handleToggleTech = (option) => {
        console.log('Selected Option:', option);
        setActiveTechOption(option.id);
    };


    const techComponents = {
        resume: <SectionTechniqueDetailsResume/>,
        contact_technique: <SectionTechniqueDetailsContactTechnique toggle={activeTab === 'tech'}/>,
        hebergeur: <SectionTechniqueDetailsHebergeur/>,
        emails: <SectionTechniqueDetailsEmails/>,
        zoneDNS: <SectionTechniqueDetailsDNSZone/>,
        domain: <SectionTechniqueDetailsDomaine/>
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Voulez-vous vraiment envoyer la demande d'avis à ${email} (en copie à ${consultantEmail})`)) {

            const data = {
                consultant: null,
                clientID: id,
                email: email,
                consultantEmail: consultantEmail,
                subject: formData.subject,
                contentFile: formData.contentFile,
                clientName: formData.clientName,
                url: siteUrl
            };

            console.log('ok')

            axios.post(`${API_BASE_URL}/send_mail_avis`, {data: data, user_id: localStorage.user_id})
                .then(response => {
                    console.log(response);
                    if (response.data.status === 'ok') {
                        setMessageState('<i class="fa-solid fa-check"></i>');

                        setAvis(response.data.data)

                        // Reset des inputs de la partie de gestion d'envoi d'email, résout un problème lorsqu'un avis est envoyé à un client puis que le client change via la barre de recherche (n'envoyait pas le mail)
                        // Globalement ce code est super important pour corriger l'erreur d'envoi d'email qui fail quand on swap de client
                        setFormData({
                            subject: '', url: '', clientEmail: '', clientName: '', contentFile: '', clientID: ''
                        });
                        setSiteUrl("");
                        setSelectedTemplate("");

                        // Revert to the initial state after 3 seconds
                        setTimeout(() => {
                            setMessageState("Envoyer la demande d'avis");
                        }, 3000);
                    }
                })
                .catch(error => {
                    alert('Erreur lors de l\'envoi : ', error);
                });
        }
    };

    const handleClick = (tab) => {
        setActiveTab(tab);
    };
    const handleUserClick = (user) => {
        console.log(user)
        setActiveUser(user);
    }

    return (<div className="md-dashboard-container p-0">
            <aside className="md-sidebar">
                <div className="md-sidebar-top">

                    <nav className="md-nav-links">
                        <ul>
                            <li>
                                <span
                                    className={activeTab === 'home' ? 'md-active' : ''}
                                    onClick={() => handleClick('home')}
                                >
                                    <h4 className={"nav-link"}>
                                        Infos Bexio
                                    </h4>
                                </span>
                            </li>
                            <li>
                                <span
                                    className={activeTab === 'details' ? 'md-active' : ''}
                                    onClick={() => handleClick('details')}
                                >
                                    <h4 className={"nav-link"}>
                                        Détails entreprise
                                    </h4>
                                </span>
                            </li>
                            <li>
                                <span
                                    className={activeTab === 'products' ? 'md-active' : ''}
                                    onClick={() => handleClick('products')}
                                >
                                    <h4 className={"nav-link"}>
                                        Produits
                                    </h4>
                                </span>
                            </li>
                            <li>
                                <span
                                    className={activeTab === 'avis' ? 'md-active' : ''}
                                    onClick={() => handleClick('avis')}
                                >
                                    <h4 className={"nav-link"}>
                                        Livraison/Avis
                                    </h4>
                                </span>
                            </li>

                            <li>

                                <span
                                    className={activeTab === 'tickets' ? 'md-active' : ''}
                                    onClick={() => handleClick('tickets')}
                                >
                                    <h4 className={"nav-link"}>Tickets
                                    </h4>
                                </span>
                            </li>
                            <li>

                                <span
                                    className={activeTab === 'tech' ? 'md-active' : ''}
                                    onClick={() => handleClick('tech')}
                                >
                                    <h4 className={"nav-link"}>Informations techniques</h4>
                                </span>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>

            {/* MAIN CONTENT */}
            <div className="md-main-content">
                {/* TOP BAR */}
                <header className="md-top-bar">
                    <div className="md-search-bar">
                        <strong>{businessData.name_1} {businessData.name_2}</strong>
                    </div>
                </header>

                {activeUser === 'details' &&
                    <InfosBexio businessData={businessData} activeUser={activeUser} handleUserClick={handleUserClick}
                                contactPeople={contactPeople}/>}

                <div className="md-content-layout">
                    {/* USER LIST */}
                    {(activeTab !== 'tickets' && activeTab !== "products" && activeTab !== "avis" && activeTab !== "details") &&

                        <section className="md-user-list">

                            {(activeTab === 'tech') ?
                                <SectionTechnique data={techComponents} onOptionSelect={handleToggleTech}/> :
                                <InfosBexio businessData={businessData} activeUser={activeUser}
                                            handleUserClick={handleUserClick} contactPeople={contactPeople}/>}
                        </section>}

                    {modalTickets && <TicketModal closeModal={() => setModalTickets(false)}/>}
                    {/* USER DETAIL */}
                    {activeTab === 'home' && <div className={"display-flex mb-40 no-radius-top flex"}>
                        {/* Fiche client */}

                        <div className={"flex"}>
                            <div>
                                <div className={`display-flex justify-content-space-between p-20 bg-white`}>

                                    <div className={'w-100 gap-20 display-flex flex-direction-column'}>

                                        {activeUser.customer_id === id && <>
                                            <div className={"display-flex flex-direction-row"}>
                                                    <span className="icon-info-client display-flex">
                                                        <i className="fa-solid fa-location-dot color-third"></i>
                                                    </span>
                                                <div className={"display-flex flex-direction-column gap-5"}>
                                                    {businessData.name_1 && <p>{businessData.name_1}</p>}
                                                    {businessData.name_2 && <p>{businessData.name_2}</p>}
                                                    {businessData.postcode &&
                                                        <p>{businessData.postcode} {businessData.city}</p>}
                                                </div>

                                            </div>
                                            {businessData.adresse && <p style={{marginLeft: "40px"}}>
                                                {businessData.adresse}
                                            </p>}
                                            {businessData.mail && <div className={"display-flex flex-direction-row"}>
                                                        <span
                                                            className="icon-info-client display-flex align-items-center display-flex align-items-center justify-content-start">
                                                            <i className="fa-solid fa-envelope mr-10 color-third"/>
                                                        </span>
                                                <p>{businessData.mail}</p>
                                            </div>}

                                            {businessData.phone_fixed &&
                                                <div className={"display-flex flex-direction-row"}>
                                                        <span
                                                            className="icon-info-client display-flex align-items-center">
                                                            <i className="fa-solid fa-phone mr-10 color-third"/>
                                                        </span>
                                                    <p>{businessData.phone_fixed}</p>
                                                </div>}


                                            {businessData.branch_names && (
                                                <div className={"display-flex flex-direction-row"}>
                                                        <span
                                                            className="icon-info-client display-flex align-items-center">
                                                            <i className="fa-solid fa-industry-windows mr-10 color-third"/>
                                                        </span>
                                                    {console.log(businessData.branch_names)}
                                                    <div className={"display-flex gap-10 flexwrap-wrap"}>
                                                        {businessData.branch_names.split(',').map((branch, index, branches) => (
                                                            <span key={"branch-" + index}
                                                                  className="background-primary p-5-10 rounded gap-10">
                                                                    {branch.trim()}
                                                                {index !== branches.length - 1}
                                                                </span>))}
                                                    </div>
                                                </div>)}

                                            {businessData.firstname && (
                                                <div className={"display-flex flex-direction-row"}>
                                                        <span
                                                            className="icon-info-client display-flex align-items-center">
                                                            {businessData.salutation_type === 'male' ?
                                                                <i className="mr-10 color-third fa-solid fa-user-tie-hair"></i> :
                                                                <i className="mr-10 color-third fa-solid fa-user-tie-hair-long"></i>}
                                                        </span>
                                                    <div className={"display-flex gap-10 flexwrap-wrap"}>
                                                             <span>
                                                                {businessData.firstname}&nbsp;{businessData.lastname}
                                                            </span>
                                                    </div>
                                                </div>)}
                                        </>}

                                        {activeUser.phone_mobile && (<p>
                                            <a style={{textDecoration: "none"}}
                                               href={"tel:" + activeUser.phone_fixed}>
                                                <span className={'icon-info-client'}>
                                                    <i className="fa-solid fa-phone mr-10 color-third"/>
                                                </span>
                                                {activeUser.phone_mobile}
                                            </a>
                                        </p>)}

                                        {activeUser.mail && (<p>
                                            <a style={{textDecoration: "none"}} href={"mailto:" + activeUser.mail}>
                                                <span className={'icon-info-client'}>
                                                    <i className="fa-solid fa-envelope mr-10 color-third"/>
                                                </span>
                                                <span>{activeUser.mail}</span>
                                            </a>
                                        </p>)}

                                        {businessData.branch_name && (<p>
                                            <span className={'icon-info-client'}>
                                                <i className="fa-solid fa-industry color-third"/>
                                            </span>
                                            <span>{businessData.branch_name}</span>
                                        </p>)}

                                        {businessData.url && (<p>
                                            <a
                                                style={{textDecoration: "none"}}
                                                target="_blank"
                                                href={businessData.url.startsWith("http://") || businessData.url.startsWith("https://") ? businessData.url : `https://${businessData.url}`}
                                                rel="noreferrer"
                                            >
                                            <span className="icon-info-client">
                                                <i
                                                    className="fa-solid fa-link color-third"
                                                    style={{marginRight: "10px"}}
                                                />
                                            </span>
                                                <span>{businessData.url}</span>
                                            </a>
                                        </p>)}


                                        {customerWebsites.length > 0 && (<>
                                            <div className="h-separator"/>
                                            <h3 className="color-third mb-10">Sites Solution Digitale rattachés au
                                                client</h3>
                                            {customerWebsites.map((website, index) => (
                                                <p key={index} className={"display-flex gap-10 align-items-center"}>
                                                            <span onClick={() => window.location = website.url}
                                                                  className={"cursor-pointer text-right display-flex h-100 p-5 border-radius-5 bg-third color-white"}>{website.url}</span>
                                                    <span
                                                        className={"text-right color-third display-flex h-100 p-5 border-radius-5 bg-primary color-white"}>{website.version}</span>
                                                </p>))}
                                        </>)}

                                        {/* Vue de l'entreprise */}
                                        {!((activeUser.name_1 || activeUser.name_2) && !activeUser.customer_id) && (<>
                                            <div className={"h-separator"}/>
                                            <div className={"display-flex flex-direction-column"}>

                                                <h3 className="color-third mb-10">Informations complémentaires</h3>
                                                <div
                                                    style={{
                                                        borderRadius: 10, border: "solid 1px rgb(221, 221, 221)"
                                                    }} className={"w-100"}>
                                                    <ReactQuill
                                                        className=" m-0 no-outline h-100 min-h-400  w-100"
                                                        id="position_note"
                                                        onChange={handleNote}
                                                        value={note}
                                                    />
                                                </div>
                                            </div>
                                        </>)}

                                        {/* On check que la vue affichée soit celle client et pas celle de l'entreprise pour pas rajouter encore le nom de la boite */}
                                        {((activeUser.name_1 || activeUser.name_2) && !activeUser.customer_id) && (
                                            <p className={"m-0"}>
                                            <span style={{textDecoration: "none"}}>
                                                <span className={'icon-info-client'}>
                                                <i className="fa-solid fa-user color-third"
                                                   style={{
                                                       marginRight: "10px"
                                                   }}/>
                                                </span>
                                                <span>{activeUser.name_1} {activeUser.name_2}</span>
                                            </span>
                                            </p>)}


                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>

                    }
                    {activeTab === 'details' && <DetailsEntreprise id={id}/>}

                    {activeTab === 'avis' &&


                        <div className={"flex p-20 client-compo-right radius-bottom-right-10"}>
                            <div className={"text-left mb-50 flex-direction-column display-flex "}>
                                <h3 className={"color-third  mb-10"}>Gestion des avis</h3>
                                <div>
                                    <span>Statut de l'avis client sur Google</span>
                                </div>
                                <label className="switch mt-20">
                                    <input type="checkbox" checked={isChecked} onChange={handleToggle}/>
                                    <span className="slider"></span>
                                </label>
                                <div className={"mt-10"}>

                                <span className={"mt-10"} style={{fontStyle: "italic", fontSize: ".8rem"}}>
                                    Si la case est cochée, le client a déjà laissé son avis sur Google.
                                </span>
                                </div>
                            </div>

                            <div className={"text-left mb-50"}>
                                <h3 className={"color-third  mb-10"}>Gestionnaire d'envoi des avis (fiche Google)</h3>
                                <form onSubmit={handleSubmit}>
                                    <label><i>Pour mettre plusieurs emails, les séparer par une virgule.</i></label>
                                    <div className={"display-flex gap-10 mt-20 btn-avis-container-global"}>
                                        <div>
                                            <div className={"btn-avis-container mb-20"}>
                                                <div className={"display-grid text-left"}>
                                                    <input
                                                        className={"text-center input-base p-15 "}
                                                        name="clientEmail"
                                                        value={email}
                                                        onChange={e => handleChangeEmail(e.target.value)}
                                                        placeholder={"Email client (aucun trouvé)"}
                                                        style={{minWidth: 300}}
                                                    />
                                                </div>
                                                <div className={""}>
                                                    <select
                                                        id="subject"
                                                        name="subject"
                                                        className={"text-center input-base p-15 "}
                                                        value={formData.subject}
                                                        onChange={handleTemplateChange}
                                                        style={{minWidth: 300}}
                                                    >
                                                        <option value="">Choisir un template d'email</option>
                                                        <option value="Demande d'avis">Demande d'avis</option>
                                                        <option value="Rappel demande d'avis">Rappel demande d'avis
                                                        </option>
                                                        <option value="Votre nouveau site est en ligne">Votre nouveau
                                                            site internet est en ligne
                                                        </option>
                                                        <option value="Vos supports de communication sont prêts">Vos
                                                            supports de communication sont prêts
                                                        </option>
                                                        <option value="Votre présence sur les réseaux sociaux">Votre
                                                            présence sur les réseaux sociaux
                                                        </option>
                                                        <option value="Lancement de votre campagne Google Ads">Lancement
                                                            de votre campagne Google Ads
                                                        </option>
                                                    </select>
                                                </div>
                                                {(selectedTemplate === "Votre nouveau site est en ligne") && (
                                                    <div className={"display-grid text-left"}>
                                                        <input
                                                            className={"text-center input-base p-15 "}
                                                            name="siteUrl"
                                                            value={siteUrl}
                                                            required={true}
                                                            onChange={handleSiteUrlChange}
                                                            placeholder={"URL du site"}
                                                            style={{minWidth: 300}}
                                                        />
                                                    </div>)}
                                            </div>
                                        </div>

                                    </div>
                                    <Button onClick={handleSubmit} icon={"fa-paper-plane"}
                                            label={messageState}
                                            textClassNames={"bg-third text-white btn-save"}
                                            iconBackground={'bg-fifth'} disableLink/>

                                </form>
                            </div>

                            <div className="text-left mb-50">
                                {avis && avis.length > 0 ? (Object.entries(avis
                                    // sort by created_date first
                                    .sort((a, b) => new Date(a.created_date) - new Date(b.created_date))
                                    // group by type
                                    .reduce((groups, item) => {
                                        if (!groups[item.type]) groups[item.type] = [];
                                        groups[item.type].push(item);
                                        return groups;
                                    }, {})).map(([type, group], i) => (
                                    <div key={i} className="mb-20">{console.log(group[0].type)}
                                        <h3 className="color-third mb-10"><i
                                            className={"pr-10 fa-solid fa-paper-plane"}/> {type}</h3>
                                        {group.map((a, j) => (<div key={`avis-${i}-${j}`} className={"my-10"}>
                                                    <span>
                                                        <strong>
                                                      {" "}
                                                            {formatDateBeautiful(a.created_date)}</strong> à {a.email}{" "}
                                                        {a.user_id ? (<>par <strong>{a.username_display}</strong></>) : ("")}

                                                </span>
                                        </div>))}
                                    </div>))) : (<span>Aucune demande d'avis n'a pour le moment été envoyée.</span>)}
                            </div>

                        </div>}

                    {activeTab === 'products' && <div className={"display-flex flex-direction-column w-100 m-20"}>

                        <div className="md-search-bar mb-20">
                            <input onChange={handleSearchChange} type="text"
                                   placeholder="Rechercher un produit"/>
                        </div>
                        <div className={"w-100"}>
                            {

                            }
                            <table className="md-table" style={{backgroundColor: "unset!important"}}>
                                <thead className="md-table-head">
                                <tr className="md-table-row">
                                    <th className="md-table-header" style={{borderRadius: "10px 0 0 0"}}>Nom du projet
                                    </th>
                                    <th className="md-table-header">Montant total</th>
                                    <th className="md-table-header" style={{borderRadius: "0 10px 0 0"}}>Date de
                                        création
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="md-table-body">
                                {/* Tri des groupes par order_start_date du plus récent au plus vieux*/}
                                {Array.isArray(totalPositionsSearch) && [...totalPositionsSearch]
                                    .sort((a, b) => new Date(b.order_start_date) - new Date(a.order_start_date)) // Sort by order_start_date
                                    .reduce((acc, position, index, array) => {
                                        const isNewGroup = index === 0 || position.order_id !== array[index - 1].order_id;

                                        if (isNewGroup) {
                                            acc.push(<tr
                                                key={"contrat-" + position.order_id + "-" + position.internal_pos}
                                                className="md-table-row group-header">
                                                <td colSpan={3}
                                                    style={{fontWeight: 'bold', background: '#f5f5f5'}}>
                                                    <strong>Contrat n°{position.order_id}</strong>{' '}
                                                    <strong dangerouslySetInnerHTML={{__html: position.title}}/>
                                                </td>
                                            </tr>);
                                        }

                                        {
                                            console.log(totalPositionsSearch)
                                        }

                                        acc.push(<tr
                                            key={"position-" + position.order_id + "-" + position.internal_pos + "-" + index}
                                            className="md-table-row"
                                            onClick={() => window.open(`/positions/${position.id}`, '_blank')}
                                            style={{cursor: 'pointer'}}
                                        >
                                            <td className="md-table-cell">

                                                <div className={"display-flex flex-direction-column"}>
                                                    <div className={"display-flex align-items-center gap-10"}>
                                                        <span className="round-button m-0 mr-10 w-50"
                                                              style={{backgroundColor: getColorFromProgress(position.progress)}}>
                                                            <span
                                                                className="t-0 d-ib w-50">{parseInt(position.progress, 10)}%</span>
                                                        </span>

                                                        <span>{position.intern_name || cleanString(position.text || position.title)}</span>
                                                        {position.is_archived === 1 &&
                                                            <span className={"cancel ml-10"} style={{
                                                                backgroundColor: "#eac80a",
                                                                borderRadius: 999,
                                                                padding: "5 10",
                                                                fontSize: ".8rem",
                                                                fontWeight: 700
                                                            }}>Annulé</span>}

                                                    </div>
                                                </div>
                                            </td>
                                            <td className="md-table-cell">{position.position_total} CHF</td>
                                            <td className="md-table-cell">
                                                {formatDateDDMMYYYY(position.order_start_date)}
                                            </td>
                                        </tr>);

                                        return acc;
                                    }, [])}
                                </tbody>

                            </table>

                        </div>

                    </div>}
                    {activeTab === 'tech' && <div className={"display-flex flex-direction-column w-100 m-20"}>

                        <SectionTechniqueDetails data={techComponents} selectedOption={activeTechOption}/>

                    </div>}
                    {activeTab === 'tickets' && <div className={"display-flex flex-direction-column w-100 m-20"}>

                        <div className={"display-flex gap-20 mb-20"}>
                            <div className="md-search-bar">
                                <input className={'h-100'} onChange={handleSearchTicketChange} type="text"
                                       placeholder="Rechercher un ticket"/>
                            </div>

                            <Button onClick={toggleModalTicket} icon={"fa-plus"}
                                    label={"Créer"}
                                    textClassNames={"bg-third text-white btn-save"}
                                    iconBackground={'bg-fifth'} disableLink/>
                        </div>


                        {totalTicketsSearch.length === 0 ?
                            <div className={"m-20 text-center"}><span className={"m-20"}>Ce client n'a pas encore de ticket.</span>
                            </div> : <div className={"w-100"}>
                                <table className="md-table">
                                    <thead className="md-table-head">
                                    <tr className="md-table-row">
                                        <th className="md-table-header">#</th>
                                        <th className="md-table-header">Type</th>
                                        <th className="md-table-header">Département</th>
                                        <th className="md-table-header">Date de création du ticket</th>
                                    </tr>
                                    </thead>

                                    <tbody className="md-table-body">
                                    {totalTicketsSearch.map((position, index) => (<tr
                                        key={"ticket-" + index}
                                        className="md-table-row"
                                        onClick={() => navigate(`/ticket/${position.id}`)}
                                    >
                                        <td className={"md-table-cell"}>{position.id}</td>
                                        <td className="md-table-cell">{position.ticket_type_name}</td>
                                        <td className="md-table-cell">{position.department_name}</td>
                                        <td className="md-table-cell">{formatDateDDMMYYYY(position.created_at)}</td>
                                    </tr>))}
                                    </tbody>
                                </table>
                            </div>}
                    </div>}
                </div>
            </div>
        </div>


    );
};

export default Client;